import { SliderProps } from '../models'
import { SliderTypes } from '../types'
import { createAction } from './create.action'

export namespace SliderAction {
  export const getSliderData = (sliders: SliderProps[]) =>
    createAction(SliderTypes.SET_SLIDER_DATA, sliders)
}

